export default __webpack_public_path__ + "static/sorare-c5829401a9a00eb0a8c5f7c7738ec3d6.png";